import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { fetchCallsList, updateCallsList } from "../thunks/callThunks";

import type { Call } from "../../utils/types/call";

interface CallState {
  callList: Call[];
  loading: boolean;
  error: string | null;
  total: number;
}

const initialState: CallState = {
  callList: [],
  loading: false,
  error: null,
  total: 0,
};

const callList = createSlice({
  name: "callList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCallsList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchCallsList.fulfilled,
        (state, action: PayloadAction<{ calls: Call[]; total: number }>) => {
          state.loading = false;
          state.callList = action.payload?.calls || [];
          state.total = action.payload.total;
        }
      )
      .addCase(fetchCallsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    builder
      .addCase(updateCallsList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCallsList.fulfilled, (state, action) => {
        state.loading = false;
        state.callList = state.callList.map((call) => {
          if (call.callId === action.payload?.callId) {
            return { ...call, ...action.payload };
          }
          return call;
        });
      })
      .addCase(updateCallsList.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });
  },
});

export default callList.reducer;
